import React from "react";
import styled from "styled-components";
import { AiOutlineMail } from "react-icons/ai";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CenteredWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`;

const IconWrapper = styled.div`
  font-size: 24px;
  margin-right: 15px;
  color: #0077cc;
`;

const TextWrapper = styled.p`
  margin: 0;
  font-size: 16px;
  color: #555;
`;

const EmailSentInfo = () => {
  let history = useHistory();
  return (
    <CenteredWrapper>
      <MessageWrapper>
        <IconWrapper>
          <AiOutlineMail />
        </IconWrapper>
        <TextWrapper>
          A link has been sent to your SMS / Email Address. Please click on the
          link to reset your password.
        </TextWrapper>
      </MessageWrapper>
      <Button
        className="Login__Button"
        label="Go to login"
        onClick={() => {
          history.push("/login");
        }}
      />
    </CenteredWrapper>
  );
};

export default EmailSentInfo;
